<script setup lang="ts">
import { LoaderCircle } from "lucide-vue-next"
import type { HTMLAttributes } from "vue"
import { Button } from "~/components/ui/button"
import { cn } from "~/lib/utils"

const { loading, class: cl } = defineProps<{
    loading?: boolean
    class?: HTMLAttributes["class"]
}>()
</script>

<template>
    <Button
        v-bind="$attrs"
        :class="cn('relative font-button capsize [&_span]:capsize', cl)"
    >
        <slot v-if="!loading" />
        <LoaderCircle
            v-else
            :class="cn('absolute flex place-items-center animate-spin size-4')"
        />
    </Button>
</template>